import { createSlice } from "@reduxjs/toolkit";
import { EMPTY_ARRAY } from "../../../helpers/menuItemMapper";

// Workflows the caller can see in the selected company, each with the permission codes usable on
// it (GET /api/Authorization/companies/{companyId}/workflows). Fetched on demand by the workflow
// pages through useWorkflowAccess, not by the post-login access-data call. Kept in memory only:
// cached across page visits, refetched in the background on each visit, cleared on company switch.
const workflowAccessSlice = createSlice({
	name: "workflowAccess",
	initialState: {
		companyId: null,
		data: null, // Full ApiResponse<List<WorkflowAccessDTO>>
		loading: false,
		error: null,
	},
	reducers: {
		fetchWorkflowAccessRequest: (state, action) => {
			// A different company's cache is wrong for this one - drop it rather than show it.
			if (state.companyId !== action.payload.companyId) {
				state.companyId = action.payload.companyId;
				state.data = null;
			}
			state.loading = true;
			state.error = null;
		},
		fetchWorkflowAccessSuccess: (state, action) => {
			state.loading = false;
			state.data = action.payload;
		},
		fetchWorkflowAccessFailure: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

export const selectWorkflowAccess = (state) => state.workflowAccess.data?.data || EMPTY_ARRAY;
export const selectWorkflowAccessLoaded = (state) => state.workflowAccess.data != null;
export const selectWorkflowAccessLoading = (state) => state.workflowAccess.loading;
export const selectWorkflowAccessError = (state) => state.workflowAccess.error;

export const { fetchWorkflowAccessRequest, fetchWorkflowAccessSuccess, fetchWorkflowAccessFailure } = workflowAccessSlice.actions;

export default workflowAccessSlice.reducer;
